import { Button, Modal, Typography } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import { formatAnnouncementDate } from './contracts';

export type PreviewContent = { title: string; body: string; publishedAt: string | null };
export function AnnouncementPreview({ content }: { content: PreviewContent }) {
  return <section className="announcement-preview" aria-label="公告內容預覽">
    <Typography.Text strong style={{ color: '#16804a' }}><NotificationOutlined /> 公告</Typography.Text>
    <Typography.Title level={4} style={{ overflowWrap: 'anywhere' }}>{content.title || '公告標題'}</Typography.Title>
    <Typography.Paragraph type="secondary">{content.publishedAt ? `${formatAnnouncementDate(content.publishedAt)}（台北時間）` : '發布日期：預覽，發布後由伺服器記錄'}</Typography.Paragraph>
    <div className="announcement-preview-body">{content.body || '公告內文'}</div>
  </section>;
}
export function AnnouncementPreviewModal({ content, onClose }: { content: PreviewContent | null; onClose: () => void }) {
  return <Modal title="公告預覽" open={!!content} centered styles={{ body: { maxHeight: 'calc(100dvh - 200px)', overflowY: 'auto' } }} onCancel={onClose} maskClosable={false} footer={<Button onClick={onClose}>關閉</Button>} destroyOnHidden>
    {content && <AnnouncementPreview content={content} />}
  </Modal>;
}
